import * as tslib_1 from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { env } from '@ivy/fts/envInfo/envInfo';
import ShareModel from '../comps/share-model.vue';
let default_1 = class extends Vue {
    constructor() {
        super(...arguments);
        this.list = [];
        this.isLoading = false;
        this.isLoadAll = false;
        this.isOK = false;
    }
    async created() {
        this.$title('奖品列表');
        await env.init();
        if (!(await env.getIsLogin())) {
            return await env.login();
        }
        this.loadMore();
    }
    async loadMore() {
        if (this.isLoading || this.isLoadAll) {
            return;
        }
        this.isLoading = true;
        let { data } = await this.$axios.get(`/api/activity/appActivity/teamActivity/getReceivdRewardInfo`, {
            params: {
                limit: 10,
                offset: this.list.length,
            },
        });
        this.isOK = true;
        this.list = this.list.concat(Array.isArray(data) ? data : []);
        this.isLoadAll = !data.length;
        this.isLoading = false;
    }
};
default_1 = tslib_1.__decorate([
    Component({
        components: {
            ShareModel,
        },
    })
], default_1);
export default default_1;
